const PIPELINE_CANDIDATE_FILTER_KEYS = [
	'applicantId',
	'stage',
	'internalStage',
	'seniority',
	'englishLevel',
	'city',
	'country',
	'owner',
	'source',
	'referrer',
	'tags',
	'currentCompensation',
	'expectedCompensation',
	'skillIds'
];

export function pickPipelineJobApplicationFilters(globalQuery = {}) {
	const filters = {};

	PIPELINE_CANDIDATE_FILTER_KEYS.forEach(key => {
		const value = globalQuery[key];
		if (value === undefined || value === null) return;
		if (Array.isArray(value) && value.length === 0) return;
		if (typeof value === 'string' && value.trim() === '') return;
		filters[key] = value;
	});

	return filters;
}

export function hasPipelineCandidateFilters(globalQuery = {}) {
	return Object.keys(pickPipelineJobApplicationFilters(globalQuery)).length > 0;
}
